import Client from "./clients/rest";

export default {
  get() {
    return Client.get("/meta/diagnostic");
  },
};
